<template>
  <div class="d-flex">
    <div class="scenari__wrapper">
      <div class="add__scenario">
        <md-button @click="displayScenarioDialog(null, false)">
          <md-icon>add</md-icon>
          Créer un scénario
        </md-button>
      </div>
      <md-tabs md-alignment="fixed">
        <md-tab
          id="tab-scenarios"
          md-label="Scénarios">
          <ul class="list">
            <li
              v-for="scenario in activeScenarios"
              :key="`active-scenario-${scenario.id}`"
              class="list__item">
              <div
                class="scenario-color"
                :style="{ backgroundColor: scenario.graphs_color }">
                <md-checkbox
                  v-if="scenario.results_generated"
                  v-model="scenario.selected"
                  @change="selectedScenariosUpdated"
                  class="md-primary"
                  :style="{ backgroundColor: scenario.graphs_color }"/>

                <span
                  v-if="scenario.description"
                  class="scenario-infos-dialog">
                  <span @click="displayScenarioInfosDialog(scenario)">
                    <md-icon>info</md-icon>
                  </span>
                </span>

              </div>
              <div class="scenario-infos">
                <router-link
                  v-if="!scenario.generating"
                  :to="{ name: scenario.results_generated ? 'Scenario results': scenario.generation_failed ? 'Scenario script' : 'Scenario settings', params: { scenarioId: scenario.id }}">
                  {{ scenario.label }}
                  <md-badge
                    class="md-secondary md-square"
                    :md-content="scenario.state_display"
                    :style="{ backgroundColor: scenarioStateColor(scenario) }"
                  />
                </router-link>

                <div v-else-if="scenario.scenario_state === 'generation_pending'">
                  {{ scenario.label }}
                  <md-badge
                    class="md-secondary md-square"
                    :md-content="scenario.state_display"
                    :style="{ backgroundColor: scenarioStateColor(scenario) }"
                  />
                </div>

                <div v-else>
                  {{ scenario.label }}
                  <span class="progress-percentage">{{ scenario.generation_percentage|displayPercentageAsInt }}</span>
                  <md-progress-bar
                    md-mode="buffer"
                    class="generation-progress-bar"
                    :md-value="scenario.generation_percentage*100"
                    :md-buffer="100" />
                </div>
              </div>
              <md-menu md-direction="bottom-start">
                <md-icon md-menu-trigger>more_vert</md-icon>
                <md-menu-content>
                  <md-menu-item
                    v-if="!scenario.generating"
                    :to="{ name: scenario.generation_failed ? 'Scenario script': 'Scenario settings', params: { scenarioId: scenario.id }}">
                    <md-icon>edit</md-icon>
                    <span>Configurer ce scénario</span>
                  </md-menu-item>
                  <md-menu-item
                    v-if="scenario.results_generated"
                    :to="{ name: 'Scenario results', params: { scenarioId: scenario.id }}">
                    <md-icon>loupe</md-icon>
                    <span>Consulter les résultats</span>
                  </md-menu-item>
                  <md-menu-item
                    v-if="scenario.results_generated"
                    @click='downloadXLSXResult(scenario)'
                    :disabled="scenario.scenario_state === 'generating_frontend_xlsx'">
                    <md-icon>cloud_download</md-icon>
                    <span>Télécharger les résultats</span>
                    <md-tooltip
                      v-if="scenario.scenario_state === 'generating_frontend_xlsx'"
                      md-direction="right">Génération du fichier en cours, le fichier sera bientôt disponible</md-tooltip>
                  </md-menu-item>
                  <md-menu-item @click="displayScenarioDialog(scenario, false)">
                    <md-icon>notes</md-icon>
                    <span>Nom, description et couleurs</span>
                  </md-menu-item>
                  <md-menu-item @click="displayScenarioDialog(scenario, true)">
                    <md-icon>filter_none</md-icon>
                    <span>Dupliquer</span>
                  </md-menu-item>
                  <md-menu-item
                    v-if="!scenario.generating"
                    @click="changeScenarioIsArchived(scenario, true)">
                    <md-icon>archive</md-icon>
                    <span>Archiver</span>
                  </md-menu-item>
                  <md-menu-item
                    v-if="!scenario.generating"
                    @click="displayScenarioDeleteDialog(scenario)">
                    <md-icon>delete</md-icon>
                    <span>Supprimer</span>
                  </md-menu-item>
                  <md-menu-item
                    v-if="scenario.generating"
                    @click="cancelGeneration(scenario)">
                    <md-icon>cancel</md-icon>
                    <span>Annuler la génération</span>
                  </md-menu-item>
                </md-menu-content>
              </md-menu>
            </li>
          </ul>
        </md-tab>
        <md-tab
          id="tab-archived-scenarios"
          md-label="Scénarios archivés">
          <ul class="list">
            <li
              v-for="scenario in archivedScenarios"
              :key="`archived-scenario-${scenario.id}`"
              class="list__item">
              <div
                class="scenario-color"
                :style="{ backgroundColor: scenario.graphs_color }">
                <span
                  v-if="scenario.description"
                  class="scenario-infos-dialog">
                  <span @click="displayScenarioInfosDialog(scenario)">
                    <md-icon>info</md-icon>
                  </span>
                </span>
              </div>
              <div class="scenario-infos">
                <div>
                  {{ scenario.label }}
                </div>
              </div>
              <md-menu md-direction="bottom-start">
                <md-icon md-menu-trigger>more_vert</md-icon>
                <md-menu-content>
                  <md-menu-item @click="changeScenarioIsArchived(scenario, false)">
                    <md-icon>unarchive</md-icon>
                    <span>Désarchiver</span>
                  </md-menu-item>
                </md-menu-content>
              </md-menu>
            </li>
          </ul>
        </md-tab>
      </md-tabs>

      <md-dialog
        :md-active.sync="scenarioData.showDialog"
        @md-closed="hideScenarioDialog()"
        @md-clicked-outside="hideScenarioDialog()">
        <md-dialog-title>{{ scenarioData.dialogTitle }}</md-dialog-title>
        <md-dialog-content>
          <form
            novalidate
            class="md-layout">
            <div class="md-layout-item md-gutter p10">
              <md-field>
                <label for="scenarioLabel">Nom du scénario</label>
                <md-input
                  id="scenarioLabel"
                  v-model="scenarioData.label" />
              </md-field>
              <md-field>
                <label for="scenarioDescription">Description courte</label>
                <md-input
                  v-model="scenarioData.description"
                  id="scenarioDescription"/>
              </md-field>
              <div class="form__field">
                <div class="form__label">
                  Couleur pour le graphique
                </div>
                <div class="form__input">
                  <swatches
                    shapes="circles"
                    v-model="scenarioData.color"
                    popover-to="right"
                    colors="text-advanced"
                    inline />
                </div>
              </div>
            </div>
          </form>
        </md-dialog-content>
        <md-dialog-actions>
          <md-button
            @click="scenarioData.showDialog = false">Annuler</md-button>
          <md-button
            @click="postScenario()"
            class="md-primary">Valider</md-button>
        </md-dialog-actions>
      </md-dialog>

      <md-dialog-alert
        :md-active.sync="scenarioCommentModal.show"
        :md-title="scenarioCommentModal.title"
        :md-content="scenarioCommentModal.content"
        md-confirm-text="Ok" />

      <md-dialog-confirm
        :md-active.sync="scenarioDeleteModal.show"
        :md-title="scenarioDeleteModal.title"
        :md-content="scenarioDeleteModal.content"
        md-confirm-text="Oui, supprimer le scénario"
        md-cancel-text="Non, conserver le scénario"
        @md-cancel="scenarioDeleteModal.show = false;"
        @md-confirm="deleteScenario" />

    </div>
    <div class="content">
      <md-card>
        <md-card-content>
          <h2>Comparer les scénarios </h2>
          <md-content>
            <BarChart
              :options="scenariosChart.chartOptions"
              :chart-data="scenariosChart.dataCollection"
              :width="800"
              :height="450"
              :gen-legend="true" />
          </md-content>
          <h3>Données</h3>
          <md-table>
            <md-table-row>
              <md-table-head>Scénario</md-table-head>
              <!-- <md-table-head>Atteinte objectif 2050</md-table-head> -->
              <md-table-head>Investissements moy/an</md-table-head>
              <md-table-head>Économies moy/an</md-table-head>
              <md-table-head>Temps de retour</md-table-head>
            </md-table-row>
            <template
              v-for="scenario in generatedScenarios"
            >
              <md-table-row
                v-if="scenario.selected"
                :key="`shown-scenario-${scenario.id}`"
              >
                <md-table-cell>
                  <span
                    :style="{ backgroundColor: scenario.graphs_color, display:'inline-block',height: '10px', width: '10px', borderRadius: '50%' }" />
                  <router-link :to="{ name: 'Scenario results', params: { scenarioId: scenario.id }}">
                    {{ scenario.label }}
                  </router-link>
                </md-table-cell>
                <!-- Atteinte objectif 2050
                <md-table-cell>
                  <span>{{ scenario.goal_percentage|displayPercentage }}</span>
                  <md-progress-bar
                    md-mode="determinate"
                    :class="percentageCssClass(scenario.goal_percentage)"
                    :md-value="scenario.goal_percentage*100"/>
                </md-table-cell>-->
                <md-table-cell>{{ scenario.average_investments }}</md-table-cell>
                <md-table-cell>{{ scenario.average_economies }}</md-table-cell>
                <md-table-cell>{{ scenario.return_time }}</md-table-cell>
                <md-table-cell><router-link :to="{ name: 'Scenario results', params: { scenarioId: scenario.id }}">Détail</router-link></md-table-cell>
              </md-table-row>
            </template>
          </md-table>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import 'vue-swatches/dist/vue-swatches.min.css'
import { mapGetters } from 'vuex'
import BarChart from '../components/BarChart.vue'
import FileDownload from 'js-file-download'
import session from '../api/session'
import Swatches from 'vue-swatches'
import ValuesDisplayMixin from '../mixins/ValuesDisplayMixin'

var _ = require('lodash')

export default {
  name: 'ScenarioList',
  mixins: [ValuesDisplayMixin],
  components: { Swatches, BarChart },
  data () {
    return {
      scenarios: [],
      generatingScenarios: [], // Keep a track on the ids of the scenarios that are currently generating. The list is updated on every updateScenariosStates call (every 3 seconds)
      loadComplete: false,
      preventScenariosUpdate: false, // Temp variable to prevent the updateScenariosStates function to update the scenarios list while the user is editing a scenario or changing a scenario archive state
      scenarioCommentModal: {
        show: false,
        title: '',
        content: ''
      },
      scenarioDeleteModal: {
        show: false,
        title: '',
        content: '',
        scenario: null
      },
      scenarioData: {
        showDialog: false,
        dialogTitle: '',
        scenario: null,
        duplicate: false,
        label: '',
        description: '',
        color: '#6aa84f'
      },
      scenariosChartData: {},
      scenariosChart: {
        dataCollection: {},
        chartOptions: {},
        dataLabels: [],
        datasets: []
      }
    }
  },
  created () {
    // _.debounce est une fonction fournie par lodash pour limiter la fréquence
    // d'exécution d'une opération particulièrement couteuse.
    // Pour en savoir plus sur la fonction `_.debounce` (et sa cousine
    // `_.throttle`), visitez : https://lodash.com/docs#debounce
    this.debouncedBuildChartData = _.debounce(this.buildChartData, 1000)
  },
  async mounted () {
    this.$store.dispatch('routing/update_title', 'Scénarios')
    this.$store.dispatch('routing/update_return_kwargs', null)

    await this.$store.dispatch('scenarios/initialize')
    // Load data from the api for the first time
    await this.loadApi()
    // Refresh scenarios data every 3 seconds
    this.scenarioStatesTimer = setInterval(this.updateScenariosStates, 3000)
  },
  destroyed () {
    // The timer must be stopped when the component is destroyed otherwise it will continue to run
    clearInterval(this.scenarioStatesTimer)
  },
  computed: {
    ...mapGetters('scenarios', ['selectedScenarios']),
    activeScenarios () {
      return this.scenarios.filter(scenario => scenario.archived === false).sort((a, b) => a.label.localeCompare(b.label))
    },
    archivedScenarios () {
      return this.scenarios.filter(scenario => scenario.archived).sort((a, b) => a.label.localeCompare(b.label))
    },
    generatedScenarios () {
      return this.activeScenarios.filter(scenario => scenario.results_generated).sort((a, b) => a.label.localeCompare(b.label))
    }
  },
  methods: {
    selectedScenariosUpdated () {
      let selectedScenariosId = this.scenarios.filter(scenario => scenario.selected && !scenario.archived).map(scenario => scenario.id)
      this.debouncedBuildChartData()
      this.$store.commit('scenarios/SET_SELECTED_SCENARIOS', selectedScenariosId)
    },
    async buildChartData () {
      let minYear = new Date().getFullYear()

      const keysrt = (key) => {
        return (a, b) => {
          if (a[key] > b[key]) return 1
          if (a[key] < b[key]) return -1
          return 0
        }
      }

      if (this.loadComplete) {
        this.scenariosChart.datasets = []
        this.scenarios.sort(keysrt('year'))

        for (const scenario of this.scenarios) {
          if (scenario.selected) {
            const scenarioChartData = this.scenariosChartData[scenario.id]
            if (scenarioChartData) {
              for (const year in scenarioChartData.real_consumption_data) {
                if (minYear > year) {
                  minYear = parseInt(year)
                }
              }
            } else {
              return null
            }
          }

          const nbYears = 2050 - minYear + 1
          this.scenariosChart.dataLabels = Array.from(new Array(nbYears), (val, index) => index + minYear)
        }

        let nWDisplayed = true
        let realConsumptionDisplayed = false

        for (const scenario of this.scenarios) {
          if (scenario.selected) {
            const scenarioChartData = this.scenariosChartData[scenario.id]

            const planissimmoData = []
            const nWData = []
            const realConsumptionData = []

            for (const year of this.scenariosChart.dataLabels) {
              let yearPlanissimmoData = null
              if (year in scenarioChartData.planissimmo_consolidated_data && scenarioChartData.planissimmo_consolidated_data[year] != null) {
                yearPlanissimmoData = scenarioChartData.planissimmo_consolidated_data[year] / 1000
              }
              planissimmoData.push({x: year, y: yearPlanissimmoData})

              if (year in scenarioChartData.negawatt_trajectory_data) {
                nWData.push({x: year, y: scenarioChartData.negawatt_trajectory_data[year] / 1000})
              } else {
                nWData.push({x: year, y: null})
              }

              if (year in scenarioChartData.real_consumption_data) {
                realConsumptionData.push({x: year, y: scenarioChartData.real_consumption_data[year] / 1000})
              } else {
                realConsumptionData.push({x: year, y: null})
              }
            }

            const consumptionDataset = {
              label: 'Consommation MWh (' + scenario.label + ')',
              backgroundColor: scenario.graphs_color,
              borderColor: scenario.graphs_color,
              borderWidth: 2,
              fill: false,
              data: planissimmoData,
              radius: 2,
              type: 'line',
              pointStyle: 'line',
              yAxisID: 'y-axis-consumptions',
              lineTension: 0,
              cubicInterpolationMode: 'linear'
            }

            const nWDataset = {
              label: 'Objectif MWh',
              backgroundColor: '#92CF5D',
              borderColor: '#92CF5D',
              borderWidth: 2,
              fill: false,
              data: nWData,
              radius: 2,
              borderDash: [10, 5],
              type: 'line',
              lineTension: 0,
              pointStyle: 'line',
              cubicInterpolationMode: 'linear',
              yAxisID: 'y-axis-consumptions'
            }

            const realConsumptionDataset = {
              label: 'Consommation réelle',
              backgroundColor: '#00ADEE',
              borderColor: '#00ADEE',
              pointRadius: 4,
              pointStyle: 'circle',
              fill: false,
              showLine: false,
              data: realConsumptionData,
              type: 'line',
              yAxisID: 'y-axis-consumptions'
            }

            if (realConsumptionDisplayed === false) {
              this.scenariosChart.datasets.push(realConsumptionDataset)
              realConsumptionDisplayed = true
            }

            if (nWDisplayed === false) {
              this.scenariosChart.datasets.push(nWDataset)
              nWDisplayed = true
            }

            this.scenariosChart.datasets.push(consumptionDataset)
          }
        }

        this.scenariosChart.chartOptions = {
          responsive: true,
          maintainAspectRatio: false,
          title: {display: true, text: 'Comparer les scénarios'},
          legend: false,
          legendCallback: () => {
            const legendHtml = []
            legendHtml.push('<ul>')
            // legendHtml.push('<li><span class="chart-consumption chart-symbol"></span><span class="chart-consumption-label-text">Objectif MWh</span></li>')
            legendHtml.push('<li><span class="chart-objective chart-symbol"></span><span class="chart-objective-label-text">Consommation MWh</span></li>')
            legendHtml.push('<li><span class="chart-real-consumptions chart-symbol"></span><span class="chart-real-consumptions-label-text">Consommation réelle</span></li>')
            legendHtml.push('</ul>')
            return legendHtml.join('')
          },
          scales: {
            xAxes: [{
              display: true,
              scaleLabel: {
                display: false,
                labelString: 'Années',
                fontFamily: 'Montserrat',
                fontColor: 'black',
                fontStyle: 'bold'
              },
              gridLines: {
                offsetGridLines: false
              }
            }],
            yAxes: [{
              id: 'y-axis-consumptions',
              scaleLabel: {
                display: true,
                labelString: 'MWh',
                fontFamily: 'Montserrat',
                fontColor: 'black',
                fontStyle: 'bold'
              },
              type: 'linear',
              ticks: {
                beginAtZero: true
              },
              position: 'left'
            }]
          },
          tooltips: {
            mode: 'nearest',
            callbacks: {
              label: (tooltipItem, data) => {
                let label = data.datasets[tooltipItem.datasetIndex].label || ''

                if (label) {
                  label += ': '
                }
                label += Math.round(tooltipItem.yLabel * 100) / 100
                return label
              }
            }
          }
        }

        this.scenariosChart.dataCollection = {
          labels: this.scenariosChart.dataLabels,
          datasets: this.scenariosChart.datasets
        }
      }
    },
    displayScenarioDialog (scenario, duplicate) {
      this.scenarioData.scenario = scenario
      this.scenarioData.duplicate = duplicate
      this.scenarioData.label = ''
      this.scenarioData.description = ''
      this.scenarioData.color = '#6aa84f'

      if (duplicate) {
        this.scenarioData.dialogTitle = 'Dupliquer ' + scenario.label
        this.scenarioData.label = this.scenarioData.scenario.label + ' (copie)'
        this.scenarioData.description = this.scenarioData.scenario.description
        this.scenarioData.color = this.scenarioData.scenario.graphs_color
      } else if (scenario) {
        this.scenarioData.dialogTitle = 'Modifier ' + scenario.label
        this.scenarioData.label = this.scenarioData.scenario.label
        this.scenarioData.description = this.scenarioData.scenario.description
        this.scenarioData.color = this.scenarioData.scenario.graphs_color
      } else {
        this.scenarioData.dialogTitle = 'Créer un scénario'
      }

      this.preventScenariosUpdate = true
      this.scenarioData.showDialog = true
    },
    hideScenarioDialog () {
      this.preventScenariosUpdate = false
      this.scenarioData.showDialog = false
    },
    displayScenarioInfosDialog (scenario) {
      this.scenarioCommentModal.show = true
      this.scenarioCommentModal.title = scenario.label
      this.scenarioCommentModal.content = scenario.description
    },
    displayScenarioDeleteDialog (scenario) {
      this.scenarioDeleteModal.scenario = scenario
      this.scenarioDeleteModal.title = 'Supprimer ' + scenario.label
      this.scenarioDeleteModal.content = 'Êtes-vous sûr(e) de vouloir supprimer le scénario <strong>"' + scenario.label + '"</strong> ? <br> Attention, cette opération est définitive.'
      this.scenarioDeleteModal.show = true
    },
    async postScenario () {
      const label = this.scenarioData.label
      const description = this.scenarioData.description
      const color = this.scenarioData.color

      if (this.scenarioData.scenario !== null) {
        const scenarioId = this.scenarioData.scenario.id

        if (this.scenarioData.duplicate) {
          try {
            const scenarioResponse = await session.post(`/api/scenario/basis/${scenarioId}/duplicate/`, {'label': label, 'description': description, 'graphs_color': color})
            this.$router.push({name: 'Scenario settings', params: {scenarioId: scenarioResponse.data.id}})
            this.hideScenarioDialog()
          } catch (error) {
            const response = error.response
            if (response.status === 500) {
              this.hideScenarioDialog()
            }
          }
        } else {
          try {
            const scenarioResponse = await session.put(`/api/scenario/basis/${scenarioId}/`, {'label': label, 'description': description, 'graphs_color': color})
            const scenarioIndex = this.scenarios.findIndex(function (s) { return s.id === scenarioId })
            const scenario = this.scenarioData.scenario

            for (const k in scenarioResponse.data) {
              scenario[k] = scenarioResponse.data[k]
            }
            this.$set(this.scenarios, scenarioIndex, scenario)
            this.hideScenarioDialog()
          } catch (error) {
            const response = error.response
            if (response.status === 500) {
              this.hideScenarioDialog()
            }
          }
        }
      } else {
        try {
          const scenarioResponse = await session.post('/api/scenario/basis/', {'label': label, 'description': description, 'graphs_color': color})
          this.$router.push({name: 'Scenario settings', params: {scenarioId: scenarioResponse.data.id}})
          this.hideScenarioDialog()
        } catch (error) {
          const response = error.response
          if (response.status === 500) {
            this.hideScenarioDialog()
          }
        }
      }
    },
    async deleteScenario () {
      const scenarioId = this.scenarioDeleteModal.scenario.id

      try {
        await session.delete(`/api/scenario/${scenarioId}/`)
        this.scenarios = this.scenarios.filter(scenario => scenario.id !== scenarioId)
        this.scenarioDeleteModal.show = false
      } catch (error) {
        const response = error.response
        if (response.status === 500) {
          this.scenarioDeleteModal.show = false
        }
      }
    },
    async cancelGeneration (scenario) {
      const scenarioId = scenario.id

      try {
        await session.get(`/api/scenario/${scenarioId}/cancel-generation/`)
      } catch (error) {
        const response = error.response
        if (response.status === 400) {
          this.$store.commit('errors/SHOW', {'title': 'Annulation impossible', 'content': response.data[0]})
        }
      }
    },
    async changeScenarioIsArchived (scenario, archived) {
      const scenarioId = scenario.id
      this.preventScenariosUpdate = true
      scenario.selected = false

      try {
        const response = await session.patch(`/api/scenario/basis/${scenarioId}/`, {'archived': archived})
        const scenarioIndex = this.scenarios.findIndex(s => { return s.id === scenarioId })

        for (const k in response.data) {
          scenario[k] = response.data[k]
        }
        this.$set(this.scenarios, scenarioIndex, scenario)
      } catch (error) {
        const response = error.response
        if (response.status === 500) {
          this.hideScenarioDialog()
        }
      }
      this.preventScenariosUpdate = false
      this.selectedScenariosUpdated()
    },
    async loadApi () {
      this.$store.dispatch('loading/begin_loading')
      const scenarioResponse = await session.get('/api/scenario/')
      this.scenarios = []

      for (const scenario of scenarioResponse.data) {
        if (scenario.results_generated === true) {
          scenario.selected = this.selectedScenarios ? this.selectedScenarios.includes(scenario.id) && !scenario.archived : true
          this.scenariosChartData[scenario.id] = scenario
        } else {
          scenario.selected = false
        }
        this.scenarios.push(scenario)
        if (scenario.generating) {
          // Keep a track on the ids of the scenarios that are currently generating
          this.generatingScenarios.push(scenario.id)
        }
      }

      this.loadComplete = true
      await this.buildChartData()
      this.$store.dispatch('loading/end_loading')
    },
    async updateScenariosStates () {
      if (this.loadComplete && !this.preventScenariosUpdate) {
        const scenarioResponse = await session.get('/api/scenario/')
        this.scenarios = []
        // Keep a track on the ids of the scenarios that are currently generating
        const generatingScenarios = []
        let newScenariosGenerated = false // If a new scenario just finished generating, we need to update the chart data
        let scenarioGeneratedName = null

        for (const scenario of scenarioResponse.data) {
          if (scenario.generating) {
            generatingScenarios.push(scenario.id)
          }

          if (scenario.results_generated) {
            scenario.selected = this.selectedScenarios ? this.selectedScenarios.includes(scenario.id) && !scenario.archived : true

            if (!scenario.generation_failed && this.generatingScenarios.includes(scenario.id)) {
              // Case where a scenario just finished generating
              scenario.selected = !scenario.archived
              newScenariosGenerated = true
              scenarioGeneratedName = scenario.label
            }

            this.scenariosChartData[scenario.id] = scenario
          } else {
            scenario.selected = false
          }

          this.scenarios.push(scenario)
        }

        // Store the new list of generating scenarios for next iteration
        this.generatingScenarios = generatingScenarios

        if (newScenariosGenerated) {
          // If we identified new scenarios that just finished generating, we need to update the chart data
          this.selectedScenariosUpdated()

          if (scenarioGeneratedName) {
            this.$store.commit('messages/SHOW', {
              label: 'Le scénario a été généré',
              description: scenarioGeneratedName
            })
          }
        }
      }
    },
    percentageCssClass (percentage) {
      if (percentage < 0.25) {
        return 'md-slice-1'
      } else if (percentage >= 0.25 && percentage < 0.50) {
        return 'md-slice-2'
      } else if (percentage >= 0.50 && percentage < 0.75) {
        return 'md-slice-3'
      } else if (percentage >= 0.75 && percentage < 0.95) {
        return 'md-slice-4'
      } else if (percentage >= 0.95 && percentage < 1) {
        return 'md-slice-5'
      } else if (percentage >= 1) {
        return 'md-slice-6'
      }
    },
    scenarioStateColor (scenario) {
      if (scenario.generation_failed) {
        return 'rgb(255, 82, 82)'
      } else if (scenario.scenario_state === 'generation_pending') {
        return 'rgb(0, 115, 172)'
      } else if (!scenario.results_generated) {
        return 'rgb(255, 165, 17)'
      } else {
        return 'rgb(134, 173, 25)'
      }
    },
    async downloadXLSXResult (scenario) {
      this.$store.dispatch('loading/begin_loading')
      const scenarioResponse = await session.get(scenario.xlsx_result, { responseType: 'arraybuffer' })
      let filename = ''
      const disposition = scenarioResponse.request.getResponseHeader('Content-Disposition')
      if (disposition && disposition.indexOf('attachment') !== -1) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        const matches = filenameRegex.exec(disposition)
        if (matches != null && matches[1]) {
          filename = matches[1].replace(/['"]/g, '')
        }
      }
      FileDownload(scenarioResponse.data, filename, scenarioResponse.headers['content-type'])
      this.$store.dispatch('loading/end_loading')
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  padding: 20px;
}

.d-flex {
  display: flex;
  min-height: 100vh;
  > div {
    min-height: 100vh;
  }
}
.md-dialog {
  min-width: 400px;
}
.p10 {
  padding: 10px;
}
.add__scenario {
  padding: 10px;
}
.md-list-item-content {
  display: flex;
  justify-content: space-between;
}
.scenari__list {
  li {
    border-bottom: 1px solid #eee;
    display: flex;

    .sn__comment {
      font-size: 14px;
      color: #888;
      display: block;
    }
    label {
      display: flex;
      align-items: center;
    }
    .mdl-checkbox__label {
      margin-left: 10px;
      span {
        display: block;
      }
    }
  }
}
.list {
  list-style-type: none;
  padding-left: 0;
  li.list__item {
    position:relative;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 4px;
  }
}
.scenari__wrapper {
  box-shadow: none !important;
  border-right: 1px solid #ccc;
  background: #fff;
  width: 360px;
  height: 100%;
}
.md-title {
  padding: 10px;
}

.scenario-color {
  padding: 24px;
  border-radius: 50%;
  position: relative;

  .md-checkbox {
    position: absolute;
    top: 13px;
    margin: 0;
    left: 15px;
  }
}

.scenario-infos {
  margin-left: 10px;
  width: 68%;

  > * {
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;

    .md-badge {
      position: unset;
    }
  }
}

.scenario-infos-dialog{
  position: absolute;
  top: -8px;
  right: -8px;
}

.progress-percentage{
  margin-bottom: -30px;
    position: relative;
    z-index: 1;
    font-size: 80%;
}

.generation-progress-bar {
  display: block;
  min-width: 100%;
  height: 18px;
  border-radius: 9px;
}

</style>

<style lang="scss">
.chart-legend {
  ul {
    li {
      list-style: none;
      display: inline-block;
      vertical-align: middle;
      width: 25%;

      .chart-symbol {
          display: inline-block;
          width: 20px;
          vertical-align: middle;
          margin-right: 10px;
      }

      .chart-consumption {
          border: 0 none;
          border-top: 2px dashed #92CF5D;
          background: none;
          height:0;
      }

      .chart-objective {
          border-bottom: 2px solid #006EB9;
      }

      .chart-real-consumptions {
          height: 10px;
          width: 10px;
          background-color: #00ADEE;
          border-radius: 50%;
      }

      .chart-consumption-label-text {
          display: inline-block;
          vertical-align: middle;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ScenarioList.vue